var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 131.559 131.559",
    style: {
      enableBackground: "new 0 0 131.559 131.559"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Water_-_Grey"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M97.06,85.167l-8.504,10.432 c-3.198,3.923-4.339,8.938-3.117,13.703l0.1,0.388c0.876,3.417,3.386,6.291,6.833,7.828l0,0 c3.584,1.597,7.764,1.629,11.376,0.086l0.02-0.008c3.686-1.575,6.33-4.664,7.118-8.316l0.03-0.14 c0.981-4.546-0.161-9.261-3.151-13.001l-8.762-10.962C98.522,84.575,97.545,84.571,97.06,85.167z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    cx: 45.997,
    cy: 51.768,
    r: 19.843
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M32.876,66.648h-8.851 c-2.348,0-4.252-1.904-4.252-4.252V40.9c0-2.348,1.904-4.252,4.252-4.252h9.129"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M58.842,36.648H72.58 c21.653,0,39.206,17.553,39.206,39.206v0c0,2.241-1.817,4.058-4.058,4.058H85.843c-2.241,0-4.058-1.817-4.058-4.058v0 c0-5.063-4.143-9.206-9.206-9.206H59.117"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M60.262,31.837H31.297 c-3.118,0-5.669-2.551-5.669-5.669v-2.835c0-3.118,2.551-5.669,5.669-5.669h28.964c3.118,0,5.669,2.551,5.669,5.669v2.835 C65.931,29.286,63.38,31.837,60.262,31.837z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    cx: 45.78,
    cy: 24.75,
    r: 7.087
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M113.11,129.559H18.449 C9.364,129.559,2,122.195,2,113.11V18.449C2,9.364,9.364,2,18.449,2h94.662c9.084,0,16.449,7.364,16.449,16.449v94.662 C129.559,122.195,122.195,129.559,113.11,129.559z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterGrey);
export default __webpack_public_path__ + "static/media/Water - Grey.fcd2720b722fcfc2d9b4dd45d8436e60.svg";
export { ForwardRef as ReactComponent };